var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentsEmptyGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 1.5C6.5 1.22386 6.72386 1 7 1H15.1738C15.3099 1 15.4402 1.05552 15.5345 1.15373L17.3607 3.05604C17.4501 3.14916 17.5 3.27323 17.5 3.40231V14.5C17.5 14.7761 17.2761 15 17 15H14V16H17C17.8284 16 18.5 15.3284 18.5 14.5V3.40231C18.5 3.01508 18.3503 2.64285 18.0821 2.36351L16.2559 0.461202C15.973 0.166557 15.5822 0 15.1738 0H7C6.17157 0 5.5 0.671573 5.5 1.5V3.5H6.5V1.5Z",
    fill: "#03AB70"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 18.5V4.5C1 3.39543 1.89543 2.5 3 2.5H11.1546C11.7216 2.5 12.2619 2.74064 12.6412 3.16207L14.4866 5.21247L13.7433 5.88144L11.8979 3.83104C11.7083 3.62032 11.4381 3.5 11.1546 3.5H3C2.44771 3.5 2 3.94772 2 4.5V18.5C2 19.0523 2.44772 19.5 3 19.5H13C13.5523 19.5 14 19.0523 14 18.5V6.5504C14 6.30336 13.9086 6.06506 13.7433 5.88144L14.4866 5.21247C14.8171 5.57972 15 6.05632 15 6.5504V18.5C15 19.6046 14.1046 20.5 13 20.5H3C1.89543 20.5 1 19.6046 1 18.5Z",
    fill: "#03AB70"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentsEmptyGreen);
export default __webpack_public_path__ + "static/media/documents-empty-green.38a29d4a.svg";
export { ForwardRef as ReactComponent };